import { gql } from '@apollo/client';

export const GET_ALL_FLYERS = gql`
  query getAllFlyers($input: GetAllFlyersInput!) {
    getAllFlyers(input: $input) {
      items {
        flyerId
        startDate
        endDate
        submittedAt
        districtId
        title
        titleTranslations {
          es
        }
        status
        frontImageUrl
        isFavorite
        isRead
        isExpandedCommunity
        isCommunityFree
        grades
        criticalDate
        minTargetGradeOrAge
        maxTargetGradeOrAge
        type
        categories
        schoolCount
        org {
          name
        }
        email
        pages {
          imageUrl
          pageNumber
          userText
        }
        ctas {
          type
          value
          isPrimary
          id
          paragraph {
            pageNumber
            vertices {
              x
              y
            }
          }
        }
        pages {
          imageUrl
          pageNumber
          userText
        }
      }
      pagination {
        pageSize
        pageNumber
        total
      }
    }
  }
`;
